import type { CSSProperties, FC, ReactNode } from 'react';
import { PDF_BORDER } from '../constants';

type Props = {
  children: ReactNode;
  style?: CSSProperties;
};

export const ReportTr: FC<Props> = ({ children, style }) => (
  <tr
    style={{
      border: PDF_BORDER.THIN,
      padding: 0,
      boxSizing: 'border-box',
      pageBreakInside: 'avoid',
      ...style,
    }}
  >
    {children}
  </tr>
);
